import React, { useEffect, useState } from "react";
import Breadcrump from "../../Components/Breadcrump";
import refundPolicyApi from "../../api/refundPolicyApi";
import { extractCmsDescription } from "../../utils/cmsUtils";

function RefundPolicy() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchCMSDetails();
  }, []);

  const fetchCMSDetails = async () => {
    try {
      const res = await refundPolicyApi.details();

      if (res.code === 200) {
        setTitle("Return & Refund Policy");
        setDescription(extractCmsDescription(res.data, "refund-policy"));
      }
    } catch (err) {
      console.error("Refund Policy API Error:", err);
    }
  };

  return (
    <>
      <Breadcrump title={"Return & Refund Policy"} />

      <section className="terms-condition py-5">
        <div className="container">
          <div className="content text-dark">
            {description ? (
              <div
                dangerouslySetInnerHTML={{ __html: description }}
                style={{ color: "#000", fontSize: "16px" }}
              />
            ) : (
              <p>Loading...</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default RefundPolicy;
